module.exports = __webpack_public_path__ + "static/media/Avenir-Light.fae12ae4.svg";